import { IResourceItem } from 'app/context/resource/types';

/**
 * Picks the resource based on the provided identifier.
 * Identifier fallbacks to `name` if `identifier` is not explicitly provided to the resource.
 * If legacy is true, then resource is matched by `route` first and then by `name`.
 */
export const pickResource = (
  identifier?: string,
  resources: IResourceItem[] = []
): IResourceItem | undefined => {
  if (!identifier) {
    return undefined;
  }

  let resource = resources.find((r) => r.identifier === identifier);
  if (!resource) {
    resource = resources.find((r) => r.name === identifier);
  }

  return resource;
};
